import React, { useEffect, useMemo, useRef, useState } from 'react'
import './advice.scss'
import CreatableSearchSelect from '../../../common/updated-input/createble-search-select/creatable-search-select'
import { useDispatch, useSelector } from 'react-redux';
import { getAllAdvices } from '../../../../store/slices/prescriptionSlice';
import { patientAdviceAdd } from '../../../../service/api/patient-api';
import { addDoctorAdvice } from '../../../../service/api/medical-data';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { prescriptionAddSubDocument, prescriptionAddSubDocumentArray, prescriptionRemoveSubDocument, prescriptionUpdateSubDocument } from '../../../../service/api/prescription';
import {
  templateAddSubDocument,
  templateRemoveSubDocument,
  templateUpdateSubDocument
} from '../../../../service/api/template';
import UniversalLoaderForComponent from '../../../loader/universalLoaderForComponent';
import { put } from '../../../../utils/fetchAPI';
import CreatableSearchSelectAntD from '../../../common/updated-input/createble-search-select/creatable-search-select-antd';
import { DraggableList } from '../../../common/draggable-list/drgabble-list';
import { Select } from 'antd';
import { getGroups, getGroupAdvices } from '../../../../service/api/group';
import { GROUPS_CHANGED_EVENT } from '../../../common/group-manager/group-manager';

const Advice = ({ visitDetails, doctorId = "", templateId = "", updateState }) => {
  let { adviceList, isAdviceListLoading } = useSelector((state) => state.prescription);
  let { templateDetails } = useSelector((state) => state.template);
  const [options, setOptions] = useState([])
  const [prescribedAdvices, setPrescribedAdvices] = useState([])
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  let [details, setDetails] = useState()
  let timeoutIdRef = useRef()

  // The doctor whose advice groups we read (assistant -> selected doctor).
  const adviceDoctorId = visitDetails?.doctor || doctorId
  const [groups, setGroups] = useState([])
  // bumped after each pick to remount (and thus reset) the group dropdown
  const [groupPickerKey, setGroupPickerKey] = useState(0)

  useEffect(() => {
    if (doctorId || visitDetails?.doctor) {
      const payLoad = { doctorId: visitDetails?.doctor || doctorId, search: '' }
      dispatch(getAllAdvices(payLoad))
    }
  }, [visitDetails?.doctor, doctorId])

  const loadGroups = async () => {
    if (!adviceDoctorId) return
    const res = await getGroups(adviceDoctorId, 'advice')
    if (res?.status === 200) setGroups(res.data || [])
  }

  useEffect(() => {
    loadGroups()
    // refresh when groups are managed elsewhere (e.g. the section-gear modal)
    const onGroupsChanged = (e) => { if (e?.detail?.type === 'advice') loadGroups() }
    window.addEventListener(GROUPS_CHANGED_EVENT, onGroupsChanged)
    return () => window.removeEventListener(GROUPS_CHANGED_EVENT, onGroupsChanged)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adviceDoctorId])

  // Add every advice in the chosen group to the current prescription (skips ones
  // already added). Works for both the visit and the template editor.
  const addGroupToVisit = async (groupId) => {
    if (!groupId) return
    setIsLoading(true)
    try {
      const res = await getGroupAdvices(adviceDoctorId, groupId)
      const groupAdvices = res?.status === 200 ? (res.data || []) : []
      const existingIds = new Set((prescribedAdvices || []).map((p) => p?.advice?.toString?.() || p?.advice))
      const toAdd = groupAdvices.filter((a) => a?.details && !existingIds.has(a._id))
      if (toAdd.length === 0) return

      if (templateId) {
        let last
        for (const a of toAdd) {
          last = await templateAddSubDocument('advices', { advice: a._id, details: a.details }, templateId)
        }
        if (last?.status === 200) setPrescribedAdvices(last.data?.advices)
      } else {
        const payload = toAdd.map((a) => ({ advice: a._id, details: a.details }))
        const addRes = await prescriptionAddSubDocumentArray('advices', payload, visitDetails?._id)
        if (addRes?.status === 200) {
          setPrescribedAdvices(addRes.data?.advices)
          updateState(addRes.data)
        }
      }
    } finally {
      setIsLoading(false)
    }
  }


  const setOptionFun = (event) => {
    event.preventDefault()
    const payLoad = { doctorId: visitDetails?.doctor || doctorId, search: event.target.value }
    dispatch(getAllAdvices(payLoad))
  }

  const handleSubmit = (value) => {
    adviceAddFun(value?._id, value?.value)
  }

  const handleCreate = async (value) => {
    await addDoctorAdvice({ doctorId: visitDetails?.doctor || doctorId, details: value })
      .then((res) => {
        if (res.status === 200) {
          adviceAddFun(res?.data?._id, res?.data?.details)
          const payLoad = { doctorId: visitDetails?.doctor || doctorId, search: '' }
          dispatch(getAllAdvices(payLoad))
        }
      })
  }

  const adviceAddFun = async (adviceId, details) => {
    setIsLoading(true)
    if (!templateId) {
      const payLoad = {
        advice: adviceId,
        details: details
      }
      await prescriptionAddSubDocument('advices', payLoad, visitDetails?._id)
        .then((res) => {
          if (res.status === 200) {
            // prescriptionRefresh()
            setPrescribedAdvices(res?.data?.advices)
            updateState(res?.data)
          }
        }).finally(() => { setIsLoading(false) })
    }
    else if (templateId) {
      const payLoad = {
        advice: adviceId,
        details: details
      }
      if (templateId) {
        await templateAddSubDocument('advices', payLoad, templateId)
          .then((res) => {
            if (res.status === 200) {
              setPrescribedAdvices(res?.data?.advices)
            }
          }).finally(() => { setIsLoading(false) })
      }
    }
  }

  const deleteAdviceFun = async (advice) => {
    setIsLoading(true)
    if (!templateId) {
      await prescriptionRemoveSubDocument('advices', { _id: advice?._id }, visitDetails?._id)
        .then((res) => {
          if (res?.status === 200) {
            setPrescribedAdvices(res?.data?.advices)
            updateState(res?.data)
          }
        }).finally(() => { setIsLoading(false) })
    }

    else if (templateId) {

      await templateRemoveSubDocument('advices', { _id: advice?._id }, templateId)
        .then((res) => {
          if (res?.status === 200) {
            setPrescribedAdvices(res?.data?.advices)
          }
        }).finally(() => { setIsLoading(false) })
    }
  }

  useMemo(() => {
    if (visitDetails?.advices) {
      setPrescribedAdvices(visitDetails?.advices)
    } else if (templateId) {
      setPrescribedAdvices(templateDetails?.advices)
    }
  }, [visitDetails?.advices, templateDetails])

  const adviceEdit = async (value, advice, index, isUpdate) => {

    let oldAdvices = [...prescribedAdvices]
    let current = {}
    if (oldAdvices[index])
      current = oldAdvices[index]
    current = { ...current, details: value }
    oldAdvices[index] = current
    setPrescribedAdvices([...oldAdvices])
    clearTimeout(timeoutIdRef.current);
    // timeoutIdRef.current = setTimeout(async () => {

    let payLoad = {}
    payLoad._id = advice?._id
    payLoad[`advices.$.details`] = value

    if (isUpdate) {
      if (templateId) {
        await templateUpdateSubDocument("advices", payLoad, templateId).
          then((res) => {
            if (res.status == 200) {
              setPrescribedAdvices(res?.data?.advices)
              updateDoctorAdvice(advice?.advice, value, visitDetails?.doctor || doctorId)
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally()
      }
      else {
        await prescriptionUpdateSubDocument("advices", payLoad, visitDetails?._id).
          then((res) => {
            if (res.status == 200) {
              setPrescribedAdvices(res?.data?.advices)
              updateState(res?.data)
              updateDoctorAdvice(advice?.advice, value, visitDetails?.doctor || doctorId)
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally()
      }
    }

    // }, 1000);
  }

  const onChangeAdviceList = (sortedList) => {
    setPrescribedAdvices(sortedList)
    setSwapAdvicesToVisit(sortedList)
  }

  const setSwapAdvicesToVisit = async (advices) => {

    clearTimeout(timeoutIdRef.current);
    if (templateId) {
      // timeoutIdRef.current = setTimeout(async () => {
      await put(`/doctor/template/${templateId}`, { "advices": advices })
        .then((res) => {
          if (res.status === 200) {
            updateState(res?.data)
            setPrescribedAdvices(res?.data?.advices)
          }
        })
        .catch((e) => { })
        .finally(() => { })
      // }, 1500);
    } else {
      // timeoutIdRef.current = setTimeout(async () => {
      await put(`/visit/${visitDetails?._id}`, { "advices": advices })
        .then((res) => {
          if (res.status === 200) {
            updateState(res?.data)
            setPrescribedAdvices(res?.data?.advices)
          }
        })
        .catch((e) => { })
        .finally(() => { })
      // }, 1500);
    }
  }

  const updateDoctorAdvice = async (adviceId, details, doctorId) => {
    await put(`doctor/advice/update`, { adviceId: adviceId, details: details, doctorId: doctorId }).
      then((res) => {
        if (res.status == 200) {
          const payLoad = { doctorId: visitDetails?.doctor || doctorId, search: '' }
          dispatch(getAllAdvices(payLoad))
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally()
  }


  useMemo(() => {
    let allAdvices = []
    if (adviceList?.length > 0) {
      adviceList?.map((data) => {
        if (data?.details?.trim()?.length > 0)
          allAdvices.push({ value: JSON.stringify({ _id: data?._id, value: data?.details }), label: data?.details })
      })
      setOptions(allAdvices)
    }
  }, [adviceList])

  return (
    <div>
      {groups?.length > 0 && (
        <div style={{ marginBottom: '6px' }}>
          <Select
            key={groupPickerKey}
            size="large"
            allowClear
            style={{ width: '100%' }}
            placeholder="Add all advice from a group"
            onChange={(val) => { addGroupToVisit(val); setGroupPickerKey((k) => k + 1); }}
            options={groups.map((g) => ({ label: g.name, value: g._id }))}
          />
        </div>
      )}
      <CreatableSearchSelectAntD customClass='custom-color-border-1' placeHolderColor="#13AC81" handleSubmit={handleSubmit} handleCreate={handleCreate} isSearching={isAdviceListLoading} setOptionFun={setOptionFun} options={options} placeHolder='Search advice'></CreatableSearchSelectAntD>

      <div className='sub-section-list'>
        {prescribedAdvices?.length > 0 ? (
          <DraggableList
            items={prescribedAdvices}
            onReorder={onChangeAdviceList}
            getItemId={(item) => item?._id}
            renderItem={(advice, index) => (
              <div className='sub-item-row'>
                <span className='sub-index'>{index + 1}</span>
                <textarea
                  style={{ resize: "vertical" }}
                  autoComplete="off"
                  value={advice?.details || ''}
                  placeholder="Advice details"
                  rows={2}
                  onChange={(e) => { adviceEdit(e.target.value, advice, index) }}
                  onBlur={(e) => { adviceEdit(e.target.value, advice, index, true) }}
                />
                <button className='sub-del' onClick={() => deleteAdviceFun(advice)}>
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              </div>
            )}
          />
        ) : null}
        {isLoading && <UniversalLoaderForComponent></UniversalLoaderForComponent>}
      </div>
    </div>
  )
}

export default Advice
